import { actionConstants } from './actionConstants';
import { get, post, put, _delete } from './method';
import noti from './toast';
import qs from 'qs';
import moment from 'moment';

export const reportActions = {
  clearReport,
  getAlarmHistory,
  getAuditReports,
  getBatchReports,
  getGroupStatus,
  getGroupStatusStatistics,
  getLimitsChanged,
  getMktMonitors,
  getSpecificMktMonitor,
  createMktMonitor,
  editMktMonitor,
  deleteMktMonitor,
  getSMLog,
  downloadReport,
  getStatisticsSummary,
  getStatisticsChart,
  getStatisticsDetails,
  getTrendChart,
  getUserNotes,
};

const dateFormat = 'MM/DD/yyyy HH:mm:ss';

function clearReport() {
  return (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_REPORT });
  };
}

function downloadHelper(resp, fileName, format) {
  const url = window.URL.createObjectURL(new Blob([resp.data]));
  const link = document.createElement('a');
  link.href = url;
  let _format = 'pdf';
  switch (format) {
    case 'excel':
      _format = 'xls';
      break;
    case 'word':
      _format = 'doc';
      break;
    case 'csv':
      _format = 'csv';
      break;
    default:
      break;
  }
  link.setAttribute('download', `${fileName}.${_format}`); //or any other extension
  document.body.appendChild(link);
  link.click();
}

function toUTC(dt) {
  return moment.utc(dt, dateFormat).format();
}

const params = {
  responseType: 'blob',
};

function getAlarmHistory(format, sensorIds, fromDate, toDate) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_REPORT });
    const locale = localStorage.getItem('language') || 'en_US';
    return await get(
      `app/reports/alarm-history/${format}?sensorIds=${sensorIds}&fromDate=${toUTC(
        fromDate,
      )}&toDate=${toUTC(toDate)}&locale=${locale}`,
      params,
    )
      .then((resp) => {
        downloadHelper(resp, 'AlarmHistory', format);
        dispatch({
          type: actionConstants.GET_ALARM_HISTORY_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.GET_ALARM_HISTORY_FAILURE,
          data: error.message,
        });
      });
  };
}

function getAuditReports(
  start,
  end,
  departmentId,
  skipCount,
  maxResult,
  Keyword = '',
) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_REPORT });
    // const _start = new Date(start).toUTCString();
    // const _end = new Date(end).toUTCString();
    return await get(
      `app/audits?Start=${toUTC(start)}&End=${toUTC(
        end,
      )}&DepartmentId=${departmentId}&skipCount=${skipCount}&MaxResultCount=${maxResult}&Keyword=${Keyword}`,
    )
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_AUDIT_REPORTS_SUCCESS,
          data: resp,
        });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_AUDIT_REPORTS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getBatchReports(format, batchId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_REPORT });
    const locale = localStorage.getItem('language') || 'en_US';
    return await get(
      `app/reports/batch-reports/${format}?batchId=${batchId}&locale=${locale}`,
      params,
    )
      .then((resp) => {
        downloadHelper(resp, 'BatchReports', format);
        dispatch({
          type: actionConstants.DOWNLOAD_BATCH_REPORT_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DOWNLOAD_BATCH_REPORT_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getGroupStatus(format, sensorIds, fromDate, toDate) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_REPORT });
    const locale = localStorage.getItem('language') || 'en_US';
    return await get(
      `app/reports/group-status/${format}?sensorIds=${sensorIds}&fromDate=${toUTC(
        fromDate,
      )}&toDate=${toUTC(toDate)}&locale=${locale}`,
      params,
    )
      .then((resp) => {
        downloadHelper(resp, 'GroupStatus', format);
        dispatch({
          type: actionConstants.GET_GROUP_STATUS_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.GET_GROUP_STATUS_FAILURE,
          data: error.message,
        });
      });
  };
}

//prettier-ignore
function getGroupStatusStatistics({format, typeIds, groupId, groupHours, fromDate, toDate}) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_REPORT });
    const locale = localStorage.getItem('language') || 'en_US';
    return await get(
      `app/reports/group-status/statistics/${format}?typeIds=${typeIds}&groupId=${groupId}&groupHours=${groupHours}&fromDate=${toUTC(
        fromDate,
      )}&toDate=${toUTC(toDate)}&locale=${locale}`,
      params,
    )
      .then((resp) => {
        downloadHelper(resp, 'GroupStatusStatistics', format);
        dispatch({
          type: actionConstants.GET_GROUP_STATUS_STATISTICS_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.GET_GROUP_STATUS_STATISTICS_FAILURE,
          data: error.message,
        });
      });
  };
}

function getLimitsChanged(format, sensorIds, fromDate, toDate) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_REPORT });
    const locale = localStorage.getItem('language') || 'en_US';
    return await get(
      `app/reports/limits-changed/${format}?sensorIds=${sensorIds}&fromDate=${toUTC(
        fromDate,
      )}&toDate=${toUTC(toDate)}&locale=${locale}`,
      params,
    )
      .then((resp) => {
        downloadHelper(resp, 'LimitsChanged', format);
        dispatch({
          type: actionConstants.GET_LIMITS_CHANGED_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.GET_LIMITS_CHANGED_FAILURE,
          data: error.message,
        });
      });
  };
}

function getMktMonitors(deptId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await get(`app/mKTMonitors/info?departmentId=${deptId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_MKT_MONITORS_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_FETCHING });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_MKT_MONITORS_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        throw error.response.data.error.message;
      });
  };
}

function getSpecificMktMonitor(id) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await get(`app/mKTMonitors/${id}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_MKT_MONITOR_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_FETCHING });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_MKT_MONITOR_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        throw error.response.data.error.message;
      });
  };
}

function createMktMonitor(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await post(`app/mKTMonitors`, params)
      .then((resp) => {
        noti.success('MKT monitor is created');
        dispatch({
          type: actionConstants.CREATE_MKT_MONITOR_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CREATE_MKT_MONITOR_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function editMktMonitor(id, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await put(`app/mKTMonitors/${id}`, params)
      .then((resp) => {
        noti.success('MKT monitor is updated');
        dispatch({
          type: actionConstants.EDIT_MKT_MONITOR_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.EDIT_MKT_MONITOR_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function deleteMktMonitor(id) {
  return async (dispatch, getState) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await _delete(`app/mKTMonitors/${id}`)
      .then((resp) => {
        noti.success('MKT monitor is deleted');
        dispatch({
          type: actionConstants.DELETE_MKT_MONITOR_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_FETCHING });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DELETE_MKT_MONITOR_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        throw error.response.data.error.message;
      });
  };
}

function getSMLog(format, sensorIds, fromDate, toDate) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_REPORT });
    const locale = localStorage.getItem('language') || 'en_US';
    return await get(
      `app/reports/sensor/measurement-log/${format}?sensorIds=${sensorIds}&fromDate=${toUTC(
        fromDate,
      )}&toDate=${toUTC(toDate)}&locale=${locale}`,
      params,
    )
      .then((resp) => {
        downloadHelper(resp, 'SensorMeasurementLog', format);
        dispatch({
          type: actionConstants.GET_SM_LOG_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.GET_SM_LOG_FAILURE,
          data: error.message,
        });
      });
  };
}

function downloadReport(format) {
  const params = {
    responseType: 'blob',
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await get(`app/reports/sensor/${format}`, params)
      .then((resp) => {
        downloadHelper(resp, 'SensorReport', format);
        dispatch({
          type: actionConstants.DOWNLOAD_FILE_SUCCESS,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DOWNLOAD_FILE_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function getStatisticsSummary(paramsObj) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_REPORT });
    const params = qs.stringify(paramsObj, { encode: false });
    return await get(`app/reports/statistics/summary?${params}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_STATISTICS_SUMMARY_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_STATISTICS_SUMMARY_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getStatisticsChart(sensorId, paramsObj) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_REPORT });
    const params = qs.stringify(paramsObj, { encode: false });
    return await get(`app/reports/statistics/chart/${sensorId}?${params}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_STATISTICS_CHART_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_STATISTICS_CHART_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getStatisticsDetails(sensorId, paramsObj) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_REPORT });
    const params = qs.stringify(paramsObj, { encode: false });
    return await get(`app/reports/statistics/details/${sensorId}?${params}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_STATISTICS_DETAILS_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_STATISTICS_DETAILS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getTrendChart(sensorIds, fromDate, toDate) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_REPORT });
    return await get(
      `app/reports/trend-chart?sensorIds=${sensorIds}&fromDate=${toUTC(
        fromDate,
      )}&toDate=${toUTC(toDate)}`,
    )
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_TREND_CHART_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.GET_TREND_CHART_FAILURE,
          data: error.message,
        });
      });
  };
}

function getUserNotes(format, sensorIds, fromDate, toDate) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.GETTING_REPORT });
    const locale = localStorage.getItem('language') || 'en_US';
    return await get(
      `app/reports/user-notes/${format}?sensorIds=${sensorIds}&fromDate=${toUTC(
        fromDate,
      )}&toDate=${toUTC(toDate)}&locale=${locale}`,
      params,
    )
      .then((resp) => {
        downloadHelper(resp, 'UserNotes', format);
        dispatch({
          type: actionConstants.GET_USER_NOTES_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.GET_USER_NOTES_FAILURE,
          data: error.message,
        });
      });
  };
}
